<template>
  <fh-container>
    <fh-title>{{ nombreOperador }}</fh-title>

    <v-row  class="fh-cards-same-height">
      <!-- Pin -->
      <v-col cols="12" md="6">
        <v-card :to="{ name: 'ChangePin' }" class="pa-3">
          <v-card-title>
            <v-icon class="pr-3 fh-absolute">vpn_key</v-icon>
            <span class="headline ml-11 fh-word-break">
                  Cambiar Pin
                </span>
          </v-card-title>
        </v-card>
      </v-col>

      <!-- Email -->
      <v-col cols="12" md="6">
        <v-card :to="{ name: 'ChangeEmail' }" class="pa-3">
          <v-card-title>
            <v-icon class="pr-3 fh-absolute">email</v-icon>
            <span class="headline ml-11 fh-word-break">
              Cambiar Correo Electrónico
            </span>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row  class="fh-cards-same-height">
      <v-col cols="12" class="headline mt-4 text-center">
        <template v-if="rol.length === 0">No tiene sitios habilitados</template>
        <template v-if="rol.length === 1">Sitio Habilitado</template>
        <template v-if="rol.length > 1">Sitios Habilitados</template>
      </v-col>

      <v-col cols="12" md="6" v-for="sitio in rol" :key="sitio.nombre">
        <v-card :href="protocol + '//' + sitio.dominio" target="_blank" rel="noopener" class="pa-3">
          <v-card-title>
            <v-icon class="pr-3 fh-absolute">open_in_new</v-icon>
            <span class="headline ml-11 fh-word-break">
              {{ sitio.nombre }}
            </span>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </fh-container>
</template>

<script>
import FhContainer from '@/components/FhContainer'
import FhTitle from '@/components/FhTitle'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Home',
  components: { FhTitle, FhContainer },
  computed: {
    ...mapState('user', [
      'nombreOperador',
      'rol',
    ]),
    protocol () {
      return location.protocol
    },
  },
  methods: {
    ...mapActions('user', [
      'fetchRol',
    ]),
  },
  async mounted() {
    await this.fetchRol()
  },
}
</script>

<style scoped>
  /* Make cards in same row have the same height */
  /*noinspection CssUnusedSymbol*/
  .fh-cards-same-height .v-card {
    height: 100%;
  }

  .fh-absolute {
    position: absolute;
  }

  .fh-word-break {
    word-break: break-word;
  }
</style>
